
export const getDay = (name: string) => {
    switch (name) {
        case 'Lunedì': return 1;
        case 'Martedì': return 2;
        case 'Mercoledì': return 3;
        case 'Giovedì': return 4;
        case 'Venerdì': return 5;
        case 'Sabato': return 6;
        case 'Domenica': return 0;
    }
}
export const getDayProp = (name: string) => {
    switch (name) {
        case 'Lunedì': return 'monday';
        case 'Martedì': return 'tuesday';
        case 'Mercoledì': return 'wednesday';
        case 'Giovedì': return 'thursday';
        case 'Venerdì': return 'friday';
        case 'Sabato': return 'saturday';
        case 'Domenica': return 'sunday';
    }
}
export const getDayPropByDayNumber = (day:number) => {
    switch (day) {
        case 1: return 'monday';
        case 2: return 'tuesday';
        case 3: return 'wednesday';
        case 4: return 'thursday';
        case 5: return 'friday';
        case 6: return 'saturday';
        case 0: return 'sunday';
    }
}
export const addDays = (date: Date, days: number) => {
    const dt = new Date(date)
    dt.setDate(dt.getDate() + days);
    return dt;
}